<template>
    <div>
        <DeleteItemModal ref="deleteModal"></DeleteItemModal>
        <RestoreItemModal ref="restoreModal"></RestoreItemModal>
        <AggridList ref="aggridlist"
                    :componentGridOptions="gridOptions"
                    :excelColumns='["id", "name"]'
                    :service="service"
                    :deleted_filter="can('deleted-region-read')"
        >
            <template v-slot:buttons>
                <router-link
                    v-if="can('create-region')"
                    :to="{name: 'region-create'}" class="btn btn-sm btn-primary"><i
                    class="fas fa-plus-square"></i>
                    <span class="d-none d-sm-inline ml-1">
                        {{ trans("Create") }}
                    </span>
                </router-link>
            </template>
        </AggridList>
    </div>
</template>

<script>

import RegionService from "../../services/RegionService";
import IdCellRenderer from "../../aggrid/cells/IdCellRenderer";
import IdCellParams from "../../aggrid/cells/IdCellParams";
import CRUDCellRenderer from "../../aggrid/cells/CRUDCellRenderer";
import CRUDCellParams from "../../aggrid/cells/CRUDCellParams";

export default {
    data() {
        return {
            service: RegionService,
            gridOptions: {
                columnDefs: [
                    {
                        ...IdCellParams, cellRendererParams: {
                            getRoute(id) {
                                return {
                                    name: "region-detail",
                                    params: {id}
                                };
                            }
                        }
                    },
                    {
                        headerName: this.trans("region.Name"), field: "name", width: 400,
                        sort: "asc",
                        floatingFilter: true,
                        cellRenderer: (prop) => {
                            if (!prop.value) return null;
                            if (prop.data.deleted_at) {
                                return `<del>${prop.value}</del>`;
                            }
                            return prop.value;
                        }
                    },
                    {
                        ...CRUDCellParams,
                        cellRendererParams: {
                            canRead: (params) => {
                                return this.can("read-region", params.data);
                            },
                            readCb: (id) => {
                                this.$router.push({name: "region-details", params: {id}});
                            },
                            canEdit: (params) => {
                                return this.can("update-region", params.data);
                            },
                            editCb: (id) => {
                                this.$router.push({name: "region-edit", params: {id}});
                            },
                            canDelete: (params) => {
                                return this.can("delete-region", params.data);
                            },
                            canRestore: (params) => {
                                return this.can("restore-region", params.data);
                            },
                            deleteCb: (id) => {
                                this.$refs.deleteModal.show(async () => {
                                    try {
                                        await RegionService.remove(id);
                                        this.$refs.aggridlist.reload();
                                        this.swalSuccess(this.trans("region.Region deleted"));
                                    } catch (error) {
                                        let errorMsg = this.getHttpError(error, this.trans("Delete Error"));
                                        this.swalError(errorMsg);
                                    }
                                });
                            },
                            restoreCb: (id) => {
                                this.$refs.restoreModal.show(async () => {
                                    try {
                                        await RegionService.restore(id);
                                        this.$refs.aggridlist.reload();
                                        this.swalSuccess(this.trans("region.Region restored"));
                                    } catch (error) {
                                        let errorMsg = this.getHttpError(error, this.trans("Restore Error"));
                                        this.swalError(errorMsg);
                                    }
                                });
                            }
                        }
                    },
                ],
                frameworkComponents: {
                    IdCellRenderer, CRUDCellRenderer
                },
            }
        }
    }
}
</script>
